module.exports = __webpack_public_path__ + "static/bdtogo-logo-78ef84cb6659b3dcde9a88d2712e73b5.png";